import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { ActiveUserAvatar } from '@sorare/core/src/components/user/ActiveUserAvatar';

import type { AppearanceRuleContributor_appearanceRule } from './__generated__/index.graphql.ts';

type Props = {
  appearanceRule: AppearanceRuleContributor_appearanceRule;
};

export const AppearanceRuleContributor = ({ appearanceRule }: Props) => {
  const { contributor } = appearanceRule;

  if (!contributor) {
    return null;
  }

  return (
    <ActiveUserAvatar rounded editable={false} size={3} user={contributor} />
  );
};

AppearanceRuleContributor.fragments = {
  appearanceRule: gql`
    fragment AppearanceRuleContributor_appearanceRule on AppearanceRule {
      id
      contributor {
        slug
        ...ActiveUserAvatar_user
      }
    }
    ${ActiveUserAvatar.fragments.user}
  ` as TypedDocumentNode<AppearanceRuleContributor_appearanceRule>,
};
